module.exports = __webpack_public_path__ + "static/media/selected.327854d8.mp3";